<template>
  <div id="dashboard-feedback-jscode">
    <div id="alerts">
      <h1>Feedback Form JS Tracking Code</h1>
      <!-- eslint-disable -->
      <h3>Paste code before the end body tag. </h3>
      <textarea
        name="name"
        rows="10"
        cols="100">
&lt;script type=&quot;text/javascript&quot; src=&quot;https://static.machinecore.com/feedback.min.js&quot;&gt;&lt;/script&gt;
&lt;script type=&quot;text/javascript&quot;&gt;
  var modal = new feedback.Modal(&apos;{{ token }}&apos;);
  modal.propertyName = &apos;{{ propertyName }}&apos;;
  modal.stickyButtonColor = &apos;#000000&apos;;
&lt;/script&gt;
      </textarea>
      <!-- eslint-enable -->
      <br /><br /><br />
      <h1>Documentation</h1>
      <h2>Modal Object</h2>

      <h3>constructor</h3>
      @param {string} api token<br />

      <br />
      <h3>setters</h3>
      propertyName <br />
      @param {string} name of property - displayed on feedback form - default
      value "us"<br /><br />

      stickyButtonColor <br />
      @param {string} color of sticky button - HTML HEX format #ffffff - default
      value "#962222" delayAutoPopUpTime <br />
      @param {integer} time delay for modal to auto popup - in seconds (0 for
      immediate) - default value -1 seconds

      <br /><br />
      <h3>methods</h3>
      open()<br />
      Attaches Feedback Form to DOM and opens it.<br /><br />
      close()<br />
      Closes Feedback Form Modal - removes HTML from DOM and event listeners
      <br /><br />
      hideStickyButton()<br />
      Hides the sticky button. Note: sticky button defaults to show<br /><br />
      showStickyButton()<br />
      Shows sticky button. Note: sticky button defaults to show

      <br /><br /><br />
      <h1>Sample Code</h1>
      <h3>Using a link or button to open feedback modal.</h3>
      <!-- eslint-disable -->
<code>
<span class="keyword">var</span> modal = <span class="keyword">new</span> feedback.Modal(<span class="parameter">'</span><span class="parameter">{{ token }}</span><span style='color:#02d045; '>'</span>);<br>
modal.propertyName = <span class="parameter">'{{ propertyName }}'</span>; <br>

<span class="keyword">var</span> feedback_btn = document.getElementById(<span class="parameter">'</span><span class="parameter">feedback_btn</span><span class="parameter">'</span>);

<span class="keyword">this</span><span style='color:#d2cd86; '>.</span>feedback_btn.addEventListener(<span class="parameter">'</span><span class="parameter">click</span><span class="parameter">'</span>, <span class="function">function</span><span class="anonymous">()</span> { <br>
  &nbsp;  &nbsp; modal.open();<br>
  &nbsp; &nbsp;   event.preventDefault(); <br>
});
</code>
      <!-- eslint-enable -->

      <br /><br />
      <h3>Hide Sticky Button</h3>
      <!-- eslint-disable -->
<code>
<span class="keyword">var</span> modal = <span class="keyword">new</span> feedback.Modal(<span class="parameter">'</span><span class="parameter">{{ token }}</span><span style='color:#02d045; '>'</span>);<br>
modal.propertyName = <span class="parameter">'{{ propertyName }}'</span>; <br>
modal.hideStickyButton();<br>
<span class="keyword">var</span> feedback_btn = document.getElementById(<span class="parameter">'</span><span class="parameter">feedback_btn</span><span class="parameter">'</span>);

<span class="keyword">this</span><span style='color:#d2cd86; '>.</span>feedback_btn.addEventListener(<span class="parameter">'</span><span class="parameter">click</span><span class="parameter">'</span>, <span class="function">function</span><span class="anonymous">()</span> { <br>
  &nbsp;  &nbsp; modal.open();<br>
  &nbsp; &nbsp;   event.preventDefault(); <br>
});
</code>
      <!-- eslint-enable -->
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardFeedbackJSCode",
  data() {
    return {
      token: this.$route.params.token,
      propertyName: this.$route.params.property_name
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 22px;
}
h3 {
  font-size: 19px;
  font-weight: bold;
  margin-bottom: 0;
}
#alerts {
  lost-utility: clearfix;
}
textarea {
  width: 800px;
  height: 146px;
  padding: 5px 10px;
  outline: none;
  font-family: Consolas, sans-serif;
}
code {
  display: block;
  overflow-x: auto;
  font-weight: bold;
  color: #f8f8f2;
  background: #000000;
  padding: 15px;
  font-family: consolas, courier, monospace;
  width: 800px;
  border-radius: 3px;
}
code span {
  font-weight: bold;
}
code .keyword {
  color: #f92672;
}
code .function {
  color: #66d9ef;
}
code .parameter {
  color: #e6db74;
}
code .anonymous {
  color: #f92672;
}
@media (max-width: 835px) {
  textarea {
    width: 100%;
  }
  code {
    width: 100%;
  }
}
</style>
